import { render } from "./IdealIcon.vue?vue&type=template&id=80530d36"
import script from "./IdealIcon.vue?vue&type=script&lang=js"
export * from "./IdealIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__